import { StoreCategoryTitle } from '@client-monorepo/daily-fintech/stores';

export const StoreCategoryToLogoMapper: Record<string, string> = {
  [StoreCategoryTitle.GOLD_AND_COINS]: 'Gem.svg',
  [StoreCategoryTitle.DIGITAL]: 'DigitalDevice.svg',
  [StoreCategoryTitle.FASHION_AND_CLOTHING]: 'Fashion.svg',
  [StoreCategoryTitle.SPORTS_AND_TRAVEL]: 'Entertainment.svg',
  [StoreCategoryTitle.ENTERTAINMENT_AND_TOURISM]: 'Travel.svg',
  [StoreCategoryTitle.MEDICINE_AND_TREATMENT]: 'Pillbox.svg',
  [StoreCategoryTitle.BEAUTY_AND_HEALTH]: 'Beauty.svg',
  [StoreCategoryTitle.TOYS_FOR_CHILDREN_AND_BABIES]: 'GrinningFace.svg',
  [StoreCategoryTitle.HOUSEHOLD_CONSUMER]: 'ShoppingBasket.svg',
  [StoreCategoryTitle.HOME_AND_KITCHEN]: 'HomeAndKitchen.svg',
  [StoreCategoryTitle.BUILDING_TOOLS_AND_INDUSTRIAL_EQUIPMENT]: 'Tools.svg',
  [StoreCategoryTitle.BOOKS_STATIONERY]: 'Book.svg',
  [StoreCategoryTitle.CARS_AND_MOTORCYCLES]: 'Car.svg',
  [StoreCategoryTitle.EDUCATION_AND_ENTERTAINMENT]: 'Graduated.svg',
  [StoreCategoryTitle.SERVICES]: 'Tool.svg',
  [StoreCategoryTitle.RESTAURANT]: 'Restaurant.svg',
  [StoreCategoryTitle.PETS]: 'Bone.svg',
  [StoreCategoryTitle.FLOWER_AND_PLANTS]: 'Leaves.svg',
  [StoreCategoryTitle.BIRTHDAY_GIFTS_AND_ACCESSORIES]: 'Gift.svg',
  [StoreCategoryTitle.SPORT]: 'ball.svg',
  [StoreCategoryTitle.INTERNET_SERVICES]: 'Wireless.svg',
  [StoreCategoryTitle.ONLINE_SHOP]: 'Store.svg',
};

export const StoreCategoryToIconMapper: Record<string, string> = {
  [StoreCategoryTitle.GOLD_AND_COINS]: 'gem',
  [StoreCategoryTitle.DIGITAL]: 'digital-device',
  [StoreCategoryTitle.FASHION_AND_CLOTHING]: 'coat-hanger',
  [StoreCategoryTitle.SPORTS_AND_TRAVEL]: 'bowling',
  [StoreCategoryTitle.ENTERTAINMENT_AND_TOURISM]: 'wheel-bag',
  [StoreCategoryTitle.MEDICINE_AND_TREATMENT]: 'pills-box',
  [StoreCategoryTitle.BEAUTY_AND_HEALTH]: 'flower',
  [StoreCategoryTitle.TOYS_FOR_CHILDREN_AND_BABIES]: 'grinning-face',
  [StoreCategoryTitle.HOUSEHOLD_CONSUMER]: 'shopping-basket',
  [StoreCategoryTitle.HOME_AND_KITCHEN]: 'sofa',
  [StoreCategoryTitle.BUILDING_TOOLS_AND_INDUSTRIAL_EQUIPMENT]: 'tools',
  [StoreCategoryTitle.BOOKS_STATIONERY]: 'book',
  [StoreCategoryTitle.CARS_AND_MOTORCYCLES]: 'car',
  [StoreCategoryTitle.EDUCATION_AND_ENTERTAINMENT]: 'graduated',
  [StoreCategoryTitle.SERVICES]: 'wrench',
  [StoreCategoryTitle.RESTAURANT]: 'food',
  [StoreCategoryTitle.PETS]: 'bone',
  [StoreCategoryTitle.FLOWER_AND_PLANTS]: 'leaves',
  [StoreCategoryTitle.BIRTHDAY_GIFTS_AND_ACCESSORIES]: 'gift',
  [StoreCategoryTitle.SPORT]: 'ball-volleyball',
  [StoreCategoryTitle.INTERNET_SERVICES]: 'wifi',
  [StoreCategoryTitle.ONLINE_SHOP]: 'store',
};
